import { IAllCenterLabTubeData } from '@nkr/models/all-centers';
import { Table } from 'react-bootstrap';

interface IProps {
    labTubeData: IAllCenterLabTubeData,
    title: string
    label: string
}

const LabTubes = (props: IProps) => {
    return (
        <Table bordered striped condensed className='table-nkr-styled'>
            <thead>
                <tr >
                    <th colSpan={3} style={{ background: '#337ab7', color: 'white' }}><span style={{ float: 'left' }}>{props.title}</span></th>
                </tr>
            </thead>
            <tbody>
                {Object.keys(props.labTubeData)
                    .filter(x => x.includes(props.label) && props.labTubeData[x] !== '')
                    .map((x, i) =>
                        <tr key={i} >
                            <td key={`${props.label}${i}`}>{`${i + 1}. ${props.labTubeData[x]}`}</td>
                        </tr>
                    )
                }
            </tbody>
        </Table>
    );
}

export default LabTubes;